import Exchange from '@/assets/js/Exchange'
import Category from '@/assets/js/Category'

class StockUtils {
  getGoodsType(exchange, category) {
    if (this.isKCB(exchange, category)) {
      return '科创'
    } else if (this.isIndex(exchange, category)) {
      return '指数'
    } else if (this.isBK(exchange, category)) {
      return '板块'
    } else if (this.isSHAllA(exchange, category)) {
      return '沪A'
    } else if (this.isSZAllA(exchange, category)) {
      return '深A'
    } else if (this.isSHB(exchange, category)) {
      return '沪B'
    } else if (this.isSZB(exchange, category)) {
      return '深B'
    } else if (exchange === Exchange.HK_STOCKS) {
      return '港股'
    } else if (this.isZGG(exchange)) {
      return '美股'
    } else if (
      this.isJJ(exchange, category) ||
      this.isGPQQ(exchange, category)
    ) {
      return '基金'
    } else if (this.isZQ(exchange, category)) {
      return '债券'
    } else if (this.isQH(exchange)) {
      return '期货'
    } else if (exchange === Exchange.GJ_HL) {
      return '外汇'
    } else {
      return '其它'
    }
  }

  // 沪深A股集合
  isA(exchange, category) {
    return (
      this.isSHAllA(exchange, category) || this.isSZAllA(exchange, category)
    )
  }

  // 基金
  isJJ(exchange, category) {
    return this.isSHJJ(exchange, category) || this.isSZJJ(exchange, category)
  }

  // 基金(ETF,LOF)
  isJJETFLOF(exchange, category) {
    return (
      this.isSHETFLOF(exchange, category) ||
      this.isSZJJETFLOF(exchange, category)
    )
  }

  // 指数
  isIndex(exchange, category) {
    return (
      (exchange === Exchange.SH &&
        this.isCategory(category, Category.SH_INDEX)) ||
      (exchange === Exchange.SZ &&
        this.isCategory(category, Category.SZ_INDEX)) ||
      this.isGlobalIndex(exchange)
    )
  }

  // 版块
  isBK(exchange, category) {
    return exchange === Exchange.BK
  }

  // 沪市的基金
  isSHJJ(exchange, category) {
    return (
      exchange === Exchange.SH &&
      (this.isCategory(category, Category.SH_CEF) ||
        this.isCategory(category, Category.SH_OEF) ||
        this.isCategory(category, Category.SH_ETF) ||
        this.isCategory(category, Category.SH_LOF) ||
        this.isCategory(category, Category.SH_JJ))
    )
  }

  // 深市的基金
  isSZJJ(exchange, category) {
    return (
      exchange === Exchange.SZ &&
      (this.isCategory(category, Category.SZ_CEF) ||
        this.isCategory(category, Category.SZ_OEF) ||
        this.isCategory(category, Category.SZ_ETF) ||
        this.isCategory(category, Category.SZ_LOF) ||
        this.isCategory(category, Category.SZ_JJ))
    )
  }

  // 沪市的基金(ETF,LOF)
  isSHETFLOF(exchange, category) {
    return (
      exchange === Exchange.SH &&
      (this.isCategory(category, Category.SH_ETF) ||
        this.isCategory(category, Category.SH_LOF))
    )
  }

  // 深市的基金(ETF,LOF)
  isSZJJETFLOF(exchange, category) {
    return (
      exchange === Exchange.SZ &&
      (this.isCategory(category, Category.SZ_ETF) ||
        this.isCategory(category, Category.SZ_LOF))
    )
  }

  isQH(exchange) {
    return (
      exchange === Exchange.GZ_GZ_QH ||
      exchange === Exchange.GN_SPQH ||
      this.isGJSPQH(exchange)
    )
  }

  // 国际商品期货
  isGJSPQH(exchange) {
    return (
      exchange === Exchange.GJ_SPQH ||
      String(exchange).startsWith(String(Exchange.GJ_SPQH))
    )
  }

  // 债券
  isZQ(exchange, category) {
    return this.isSHZQ(exchange, category) || this.isSZZQ(exchange, category)
  }

  // 沪市的债券
  isSHZQ(exchange, category) {
    return (
      exchange === Exchange.SH &&
      (this.isCategory(category, Category.SH_ZQ) ||
        this.isCategory(category, Category.SH_ZZ) ||
        this.isCategory(category, Category.SH_HG))
    )
  }

  // 深市的债券
  isSZZQ(exchange, category) {
    return (
      exchange === Exchange.SZ &&
      (this.isCategory(category, Category.SZ_ZQ) ||
        this.isCategory(category, Category.SZ_ZZ) ||
        this.isCategory(category, Category.SZ_HG))
    )
  }

  /**
   * 中概股
   */
  isZGG(exchange) {
    return (
      exchange === Exchange.USA_CN_STOCKS ||
      String(exchange).startsWith(String(Exchange.USA_CN_STOCKS))
    )
  }

  // 是否沪市B股
  isSHB(exchange, category) {
    return exchange === Exchange.SH && this.isCategory(category, Category.SH_B)
  }

  // 是否深市B股
  isSZB(exchange, category) {
    return exchange === Exchange.SZ && this.isCategory(category, Category.SZ_B)
  }

  // 沪市的所有A股
  isSHAllA(exchange, category) {
    return (
      exchange === Exchange.SH &&
      (this.isCategory(category, Category.SH_A) ||
        (this.isCategory(category, Category.SH_ST) &&
          !this.isCategory(category, Category.SH_B)))
    )
  }

  // 深市的所有A股
  isSZAllA(exchange, category) {
    return (
      exchange === Exchange.SZ &&
      (this.isCategory(category, Category.SZ_A) ||
        this.isCategory(category, Category.SZ_ZXB) ||
        this.isCategory(category, Category.SZ_CYB) ||
        (this.isCategory(category, Category.SZ_ST) &&
          !this.isCategory(category, Category.SZ_B)))
    )
  }

  // 是否环球指数
  isGlobalIndex(exchange) {
    // 道琼斯,环球指数
    return (
      exchange === Exchange.GLOBAL_INDEX ||
      String(exchange).startsWith(String(Exchange.GLOBAL_INDEX))
    )
  }

  // 科创板
  isKCB(exchange, category) {
    return exchange === Exchange.SH && this.isCategory(category, Category.SH_KCB)
  }

  // 判断catogry统一使用此方式
  isCategory(category, targetCategory) {
    return (category & targetCategory) > 0
  }

  // 是否已退市
  isDelist(exchange, name) {
    // 上海 '退市%'
    // 深圳 '%退'
    if (exchange === Exchange.SH) {
      // 上海
      return name.startsWith('退市')
    } else {
      return name.endsWith('退')
    }
  }
}

export default new StockUtils()
